import filters from "./filters";
import matchesWatcher from "./matches";
import extraMarkets from "./extraMarkets";
import resultWatcher from "./results";
import topMatches from "./topMatches";
import favouriteWatcher from "./favourites";
import myBetsWatcher from "./mybets";
import betSlipWatcher from "./betSlip";
import topSponsoredEventWatcher from "./topSponsoredEvent";
import extramarketFilterWatcher from "./extramarketFilter";
import sportsIframeWatcher from "./sportsIframe";

export const sportbookNodeWatchers = [
  filters(),
  matchesWatcher(),
  extraMarkets(),
  resultWatcher(),
  topMatches(),
  favouriteWatcher(),
  myBetsWatcher(),
  betSlipWatcher(),
  topSponsoredEventWatcher(),
  extramarketFilterWatcher(),
  sportsIframeWatcher()
];
